export const TIN_REGEX = /^((\d{9})|(\d{3}-\d{2}-\d{4})|(\d{2}-\d{7}))$/;
export const TIN_LAST_FOUR_REGEX = /^((\d{4}))$/;